import { useEffect } from 'react';
import ActivityService from '../services/ActivityService';

export const useActivityTracking = (token) => {
  useEffect(() => {
    
    if (token) {
      ActivityService.connect(token);
    } else {
      ActivityService.disconnect();
    }

    const handleVisibilityChange = () => {
      if (document.hidden) {
        ActivityService.disconnect();
      } else if (token) {
        ActivityService.connect(token);
      }
    };

    const handleBeforeUnload = () => {
      ActivityService.disconnect();
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('beforeunload', handleBeforeUnload);
      ActivityService.disconnect();
    };
  }, [token]);

  // Debug function - you can call this from browser console
  window.getActivityStatus = () => {
    const status = ActivityService.getStatus();
    return status;
  };
};